import { getCurrentPermissions } from '../AppShell/Authentication/AuthorisationAsync';
import { AuthState } from '../AppShell/Authentication/AuthorisationModels';
import { AuthorisationPermissions } from '../AuthorisationPermissions';
import { GeneralPermissions } from '../GeneralPermissions';

export type AllApplicationPermissions = AuthorisationPermissions | GeneralPermissions;

export interface Permission {
    definitionCode: AuthorisationPermissions;
    state: AuthState;
}

let permissions: Permission[];

export async function loadAuthorisationPermissions() {
    const newPermissions = await getCurrentPermissions();
    setAuthorisationPermissions(newPermissions);
}

export function setAuthorisationPermissions(newPermissions: Permission[]) {
    permissions = newPermissions ?? [];
}

export function getAuthorisationPermissions(): Permission[] {
    if (permissions) return permissions;

    throw new Error(
        'No authorisation permissions, please make sure your application calls setAuthorisationPermissions'
    );
}
